import { useQuery } from '@tanstack/react-query';
import { fetchShipmentFieldsVisibility } from '../data-provider/shipment-fields-visibility';

export const useGetShipmentFieldsVisibility = () => {
  return useQuery({
    queryKey: ['shipment-fields-visibility'],
    queryFn: () => fetchShipmentFieldsVisibility(),
  });
};
